import { render, staticRenderFns } from "./_shared.html?vue&type=template&id=2311ede4&"
import script from "./Transmissoes.vue?vue&type=script&lang=js&"
export * from "./Transmissoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports